import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7f260af7")

_pushScopeId("data-v-7f260af7")
const _hoisted_1 = { class: "SSearchInput" }
const _hoisted_2 = { class: "SSearchInput__icon" }
const _hoisted_3 = {
  key: 0,
  class: "SSearchInput__line"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_search = _resolveComponent("icon-search")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_icon_search)
    ]),
    _createVNode("input", {
      type: "search",
      placeholder: _ctx.placeholder,
      value: _ctx.value,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateValue && _ctx.updateValue(...args)))
    }, null, 40, ["placeholder", "value"]),
    (_ctx.$slots.select)
      ? (_openBlock(), _createBlock("span", _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.$slots.select)
      ? _renderSlot(_ctx.$slots, "select", { key: 1 }, undefined, true)
      : _createCommentVNode("", true)
  ]))
})